import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngxs/store';
import { UserState } from '../store/users-store/user.state';
import { environment } from '../environments/environment';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { httpTokenInterceptor } from './interceptors/http.interceptor';
import { GeneralState } from '../store/general-store/general.state';
import { DemoRequestsState } from '../store/demo-requests-store/demo-requests.state';
import { OrganizationState } from '../store/organizations-store/organizations.state';
import { GroupState } from '../store/groups-store/groups.state';
import { InvitationState } from '../store/invitations-store/invitation.state';
import { RolesPermissionState } from '../store/roles-permission-store/roles-permission.state';
import { ProductState } from '../store/products-store/products.state';
import { QrState } from '../store/qr-store/qr.state';
import { DashboardState } from '../store/dashboard-store/dashboard.state';
import { SubscriptionState } from '../store/subscription-store/subscription.state';
import { httpErrorInterceptor } from './interceptors/error.interceptor';
import { ConfirmationService } from 'primeng/api';
import { RecallManagementState } from '../store/recall-management-store/recall-management.store';
import { ReportState } from '../store/report-store/report.store';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { ResourceState } from '../store/resource-store/resource.state';
import { PrintersState } from '../store/printers-store/printers.state';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider,
} from '@abacritt/angularx-social-login';
import { PublicExperienceState } from '../store/public-experience-store/public-experience.state';
import { AntiCounterfeitState } from '../store/anti-counterfeit-store/anti-counterfeit.state';
import { ApiKeysState } from '../store/api-keys-store/api-keys.state';
import { EudrState } from '../store/eudr-store/eudr.state';
import { TraceabilityState } from '../store/traceability-store/traceability.state';

const states = [
  GeneralState,
  UserState,
  DemoRequestsState,
  OrganizationState,
  GroupState,
  InvitationState,
  RolesPermissionState,
  ProductState,
  QrState,
  SubscriptionState,
  DashboardState,
  RecallManagementState,
  ReportState,
  ResourceState,
  PrintersState,
  PublicExperienceState,
  AntiCounterfeitState,
  ApiKeysState,
  EudrState,
  TraceabilityState,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    importProvidersFrom(SocialLoginModule),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('GOOGLE_CLIENT_ID'),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('FACEBOOK_APP_ID'),
          },
        ],
        onError: (err) => {
          console.error('Social Auth Error:', err);
        },
      } as SocialAuthServiceConfig,
    },
    provideToastr(),
    provideStore(states, withNgxsReduxDevtoolsPlugin({ disabled: environment.production })),
    provideHttpClient(withInterceptors([httpTokenInterceptor, httpErrorInterceptor])),
    ConfirmationService,
  ],
};
